// Vitals section questionnaire constants
export enum VitalsQuestionnaireItem {
  VITALS_TEMPERATURE = 'vitals/temperature',
  VITALS_PULSE = 'vitals/pulse',
  VITALS_RESPIRATIONS = 'vitals/respirations',
  VITALS_O2_SATURATION = 'vitals/o2-saturation',
  VITALS_BLOOD_PRESSURE = 'vitals/blood-pressure',
  VITALS_HEIGHT = 'vitals/height',
  VITALS_BLOOD_SUGAR = 'vitals/blood-sugar',
  VITALS_WEIGHT = 'vitals/weight'
}
